
import { COPY } from './copy'
import SoaCard from './SoaCard.vue'

export default {
    components: { SoaCard },
    props: {
        people: { type: Array, required: true },
    },
    data () {
        return { COPY }
    },
}
